import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { getWindowGreatestZIndex } from 'components/DeviceView/helpers/getWindowGreatestZIndex';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface ActivateWindowCommand {
  deviceViewEntityId: DeviceViewEntityId;
}

export const activateWindow: DeviceViewCommandFactory<ActivateWindowCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const foundWindow = draft.deviceViewWindows.find(
        (win) => win.id === command.deviceViewEntityId,
      );
      if (foundWindow) {
        const currentZIndex = foundWindow.zIndex;
        const greatestZIndex = getWindowGreatestZIndex(draft.deviceViewWindows);
        if (currentZIndex !== greatestZIndex) {
          foundWindow.zIndex = greatestZIndex + 1;
        }
      }
    });
  };
